angular.module('data-ng-path-item').constant('TaskFn', {
  applySubstitutionToText: function applySubstitutionToText(tasks, items, property) {
    _.each(tasks, function (task) {
      var substitute = task.substitute_text_by_field_by_item[task.item];

      if (!_.isEmpty(substitute) && !_.isEmpty(substitute[property])) {
        task['_' + property] = substitute[property];
      } else {
        task['_' + property] = items[task.item][property];
      }
    });
  }
});



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/functions/task_fn.js